// extracted by mini-css-extract-plugin
export var lg = "_39-4";
export var md = "_39-3";
export var sm = "_39-2";
export var xs = "_39-1";
export var xxs = "_39-0";